<h2 mat-dialog-title class="dialog-title">Produtos em campanha</h2>
<h4 style="margin: 0px; padding: 10px 24px 0px 24px;">Tem atualmente no seu carrinho produtos em campanha que não
  perfazem as unidades em que
poderá usufruir da mesma, quer reavaliar as quantidades atuais?</h4>

<mat-dialog-content class="mat-typography mat-dialog-container table-responsive-div">
  <table class="table">
    <thead>
      <tr>
        <th>Produto</th>
        <th class="td-text-center quantity-cell">Quantidade</th>
        <th class="td-text-center">Referencia</th>
        <th class="td-text-center">Valor</th>
        <th class="td-text-center">Total do Produto</th>
      </tr>
    </thead>
    <tbody>
      @for (product of this.data.products; track product) {
        <tr>
          <td>
            <span>{{ product.memoria }}</span>
            @if (product.bonusProductInfo.length > 0 || hasActiveQuantityCampaign(product)) {
              <span
                (click)="openProductBonus(product)" class="cursor-pointer bcg-ball ">
                <mat-icon svgIcon="discount"
                style="height: 20px; transform: scaleX(-1) rotate(90deg);"></mat-icon>
              </span>
            }
          </td>
          <td class="td-text-center">
            <div class="d-flex flex-row align-items-center justify-content-center">
              <div class="less-btn">
                <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                  (click)="removeQuantityClick(product)" />
                </div>
                <input #input class="number-input" type="number" [ngModel]="product.qtd" max="1000"
                  (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(input)"
                  (blur)="changeQuantity(input.value, product, product.qtd)" />
                  <div class="plus-btn">
                    <img src="../../../assets/Icons/plus-icon.png" alt="plusIcon"
                      (click)="addQuantityClick(product)" />
                    </div>
                  </div>
                </td>
                <td class="td-text-center">{{ product.referencia }}</td>
                <td class="td-text-center">
                  @if (product) {
                    <!-- Step 1: Lab Discount -->
                    @if (product.labDiscount && product.labDiscount > 0) {
                      @if (product.valor) {
                        <span class="slashedPrice">{{ product.valor | number: '1.2-2' }}€
                        </span>
                      }
                      <span class="discountPercentageSection">{{ product.labDiscount }}%</span>
                    }
                    <!-- Step 2: Campaign Discount -->
                    @if (getApplicableCampaign(product); as campaign) {
                      <span class="slashedPrice">
                        {{ getLabDiscountPrice(product) | number: '1.2-2' }}€
                      </span>
                      @if (campaign.discountPercentage > 0) {
                        <span class="discountPercentageSection">
                          -{{ campaign.discountPercentage }}%
                        </span>
                      }
                    }
                    <!-- Step 3: Bio2 Discount -->
                    @if (product.discountPercentage && product.discountPercentage > 0) {
                      <span class="slashedPrice">
                        {{ getCampaignDiscountPrice(product, getApplicableCampaign(product)) | number:
                        '1.2-2' }}€
                      </span>
                      <span class="discountPercentageSection">{{ product.discountPercentage }}%</span>
                    }
                    <!-- Step 4: Other Discount (if present) -->
                    @if (product.otherDiscount && product.otherDiscount > 0) {
                      <span class="slashedPrice">
                        {{ getBio2DiscountPrice(product) | number: '1.2-2' }}€
                      </span>
                      <span class="discountPercentageSection">{{ product.otherDiscount }}%</span>
                    }
                    <!-- Final price (after all discounts) -->
                    <span class="ms-2 fw-bold">
                      {{ getFinalDiscountedPrice(product) | number: '1.2-2' }}€
                    </span>
                  }
                </td>
                <td class="td-text-center">
                  {{ getFormattedTotal(product) }} €
                </td>
              </tr>
              @for (bonusInfo of product.bonusProductInfo; track bonusInfo) {
                @if (bonusInfo.bonusAccumulated > 0) {
                  <tr class="bonus-row">
                    <td>
                      <span class="font-weight-bold">Bónus: </span>
                      <span>{{ bonusInfo.bonusProductName }}</span>
                    </td>
                    <td class="td-text-center">
                      <div class="checkout-bonus-container">
                        <span>{{ bonusInfo.bonusAccumulated }}</span>
                      </div>
                    </td>
                    <td class="td-text-center">
                      <span>{{ bonusInfo.bonusProductReference }}</span>
                    </td>
                    <td colspan="4"></td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>

      </mat-dialog-content>

      <mat-dialog-actions class="d-flex mat-dialog-actions">
        <button type="cancel" class="checkout-dialog-btn-cancel" (click)="onCancel()">Cancelar</button>
        <button type="submit" class="checkout-dialog-btn-green" (click)="onConfirm()">Continuar</button>
      </mat-dialog-actions>